import React, { useEffect, useCallback, useState, useRef } from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'

import Pagination from '../components/paging'
import { Link } from 'react-router-dom'

const pageSize = 20

const Users = () => {
	const [users, setUsers] = useState<any[]>([])
	const [totalCount, setTotalCount] = useState(0)
	const [pageIndex, setPageIndex] = useState(0)
	const [pageDirection, setPageDirection] = useState<'desc' | 'asc'>('asc')

	const lastUser = useRef<firebase.firestore.DocumentData | null>(null)

	useEffect(
		() => {
			let ref = firebase.firestore().collection('users')
				.orderBy('firstName', pageDirection)
				.orderBy(firebase.firestore.FieldPath.documentId(), pageDirection)

			if (lastUser.current) {
				ref = ref.startAfter(lastUser.current.firstName, lastUser.current.id)
			}

			const sub = ref
				.limit(pageSize)
				.onSnapshot(snap => {
					if (snap.size > 0) {
						lastUser.current = snap.docs[snap.size - 1].data()
					}

					const t = snap.docs.map(d => ({ ...d.data(), id: d.id }))
					setUsers((pageDirection) === 'asc' ? t : t.reverse())
				})

			return sub
		},
		[pageDirection, pageIndex],
	)

	useEffect(
		() => {
			const sub = firebase.firestore().doc('metadata/users')
				.onSnapshot(snap => {
					setTotalCount(snap.data()?.count)
				})

			return sub
		},
		[],
	)

	const handlePageChange = useCallback(
		(ix) => {
			setPageIndex(prev => {
				if (prev > ix) {
					lastUser.current = users[0]
					setPageDirection('desc')
				} else {
					lastUser.current = users[users.length - 1]
					setPageDirection('asc')
				}

				return ix
			})
		},
		[users],
	)

	return (
		<div className="flex flex-col container mt-4 mx-auto">
			<div className="mb-8 font-semibold text-lg text-gray-600 subpixel-antialiased">
				Users
			</div>
			<div className="self-end items-center mb-4">
				<Pagination onPageIndexChange={handlePageChange} pageIndex={pageIndex} pageSize={pageSize} totalCount={totalCount} />
			</div>
			<div className="bg-white shadow-xs rounded">
				<table className="text-left w-full text-sm">
					<thead className="border-b bg-offWhite">
						<tr>
							<th className="p-2">
								Name
							</th>
							<th className="p-2">
								Company
							</th>
							<th className="p-2">
								Balance
							</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{
							users.map(t => (
								<tr className="border-t" key={t.id.toString()}>
									<td className="p-2">
										{t.firstName} {t.lastName}
									</td>
									<td className="p-2">
										{t.storeName || '-'}
									</td>
									<td className="p-2">
										{t.pointsBalance || 0}
									</td>
									<td className="text-right p-2">
										<Link to={`/users/${t.id}`}>
											<button className="bg-indigo-600 hover:bg-indigo-800 h-6 text-xs">View</button>
										</Link>
									</td>
								</tr>
							))
						}
					</tbody>
				</table>
			</div>
		</div>
	)
}

export default Users
